export enum SpecialFolderTypeEnum {
  None = 0,
  QuickShare,
  AiGrant,
  EmailGrant,
  LocalFilesForCloudSharing,
}
